import React from 'react';
import { Paper, Typography } from '@mui/material';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';

export default function CrmWeeklyActivityChart({ activityData }) {
  return (
    <Paper sx={{ p: 3, height: 340 }}>
      <Typography variant="h6" fontWeight={600} gutterBottom>
        Weekly CRM Activity
      </Typography>
      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={activityData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="Contacts" stroke="#1976d2" strokeWidth={2} />
          <Line type="monotone" dataKey="Properties" stroke="#388e3c" strokeWidth={2} />
          <Line type="monotone" dataKey="Tasks" stroke="#fbc02d" strokeWidth={2} />
          <Line type="monotone" dataKey="Notes" stroke="#7b1fa2" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </Paper>
  );
}
